import * as logger from 'loglevel';
import prefix from 'loglevel-plugin-prefix';
import {getConfigValue} from '@elixir/config';

const DEFAULT_LOGGER_CONFIG = {
    level: 'WARN',
    prefixTemplate: '%l:',
    loggerName: 'elixir-logger'
};

class Logger {

    constructor(loggerConfig) {
        const config = loggerConfig || getConfigValue('logger', DEFAULT_LOGGER_CONFIG);
        this.setConfig(config);
    }

    /**
     * @param {Object} config
     * @param {string|number} config.level - Log levels: TRACE {1}, DEBUG {2}, INFO {3}, WARN {4}, SILENT {5}
     * @param {Object} config.prefixTemplate - Prefix template documentation is avaiable on https://github.com/kutuluk/loglevel-plugin-prefix
     * @param {string} [config.loggerName] - loggerName should be used when creating new instance of Logger, by default the loggerName is `elixir-logger`
     * @param {Boolean} [replace] - replace all default logger configuration, by default logger merges DEFAULT_LOOGER_CONFIG with config provided
     */
    setConfig(config, replace) {
        const configs = replace ? config : {...DEFAULT_LOGGER_CONFIG, ...config};
        const { level, prefixTemplate, loggerName } = configs;
        prefix.reg(logger);
        prefix.apply(logger, {
            template: prefixTemplate
        });
        this.log = logger.getLogger(loggerName);
        this.log.setLevel(level);
    }

    resetConfig() {
        this.setConfig(DEFAULT_LOGGER_CONFIG);
    }

    trace(message) {
        this.log.trace(message);
    }

    debug(message) {
        this.log.debug(message);
    }

    info(message) {
        this.log.info(message);
    }

    warning(message) {
        this.log.warn(message);
    }

    error(message) {
        this.log.error(message);
    }
}
export default Logger;
export const log = new Logger();
export const trace = (message) => log.trace(message);
export const debug = (message) => log.debug(message);
export const info = (message) => log.info(message);
export const warning = (message) => log.warning(message);
export const error = (message) => log.error(message);
